import { useLazyFetch } from "hooks/fetch/useLazyFetch";

/**
 * Provides a callback function which can be used to patch to the url passed in
 * @param url the url to patch to
 * @param onCompleted callback that is fired when the patch completes successfully
 * @param onError callback that is fired when the patch errors
 * @returns {{patchCallback: ((function(*=, *=): void)|*), loading: boolean, error: boolean}}
 *
 * loading - true when patch is currently happening.
 *
 * error - true when an error has occured.
 *
 * patchCallback - the patch callback function, takes a body object and returns a promise which will contain json from the response.
 */
export function useFetchPatch(
  url,
  onCompleted = undefined,
  onError = undefined
) {
  const { loading, error, fetchCallback } = useLazyFetch(
    url,
    "PATCH",
    onCompleted,
    onError
  );

  return { loading, error, patchCallback: fetchCallback };
}
